import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateRegistrationFormAdjustment(
    $formId: Int!
    $formFieldId: Int
    $formAdjustmentDefinitionId: Int!
    $answerToMatch: String
    $amount: Int
    $maxAmount: Int
    $maxQuantity: Int
    $amountType: String
    $appliesTo: String
    $couponCode: String
    $enabled: Boolean!
    $qualifyingCount: Int
    $qualifyingOperator: String
    $startDate: String
    $endDate: String
  ) {
    createRegistrationFormAdjustment(
      formId: $formId
      input: {
        formFieldId: $formFieldId
        formAdjustmentDefinitionId: $formAdjustmentDefinitionId
        answerToMatch: $answerToMatch
        amount: $amount
        maxAmount: $maxAmount
        maxQuantity: $maxQuantity
        amountType: $amountType
        appliesTo: $appliesTo
        couponCode: $couponCode
        enabled: $enabled
        qualifyingCount: $qualifyingCount
        qualifyingOperator: $qualifyingOperator
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      id
    }
  }
`;
